module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.26d7cb06.png";